import React from 'react';
import { IMeetingOperatorsUpdateBulkJobDetails, IMeetingOperatorsUpdateBulkJobResult } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';

const meetingOperatorsUpdateBulkJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IMeetingOperatorsUpdateBulkJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: () => {
        return <div>Meetings successfully updated</div>;
    },
    failedComponent: (props: IJobResultComponentProps<IMeetingOperatorsUpdateBulkJobDetails, IMeetingOperatorsUpdateBulkJobResult>) => {
        return <AlertErrorMessage title='Update Failed' message={props.result?.failureReason || 'Unknown failure reason'} />;
    },
};

export { meetingOperatorsUpdateBulkJobProperties };
